import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import itTranslationsRaw from './locales/it.json';
import enTranslationsRaw from './locales/en.json';
import esTranslationsRaw from './locales/es.json';
import frTranslationsRaw from './locales/fr.json';

// Handle both default and direct imports (production vs development)
const itTranslations = (itTranslationsRaw as any).default || itTranslationsRaw;
const enTranslations = (enTranslationsRaw as any).default || enTranslationsRaw;
const esTranslations = (esTranslationsRaw as any).default || esTranslationsRaw;
const frTranslations = (frTranslationsRaw as any).default || frTranslationsRaw;

// Ensure translations are properly loaded
const resources = {
  it: {
    translation: itTranslations || {},
  },
  en: {
    translation: enTranslations || {},
  },
  es: {
    translation: esTranslations || {},
  },
  fr: {
    translation: frTranslations || {},
  },
};

// Initialize i18n synchronously
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'it',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
    // Ensure i18n is initialized before rendering
    initImmediate: false,
  }, (err) => {
    if (err) {
      console.error('❌ i18n initialization error:', err);
    }
  });

export default i18n;
